import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorUserRoleUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.userRoles.update),
			switchMap((action) =>
				this.vendorAdminService.updateUserRoles(action.username, action.roles).pipe(
					map(() => VendorAdminActions.userRoles.updateSuccess()),
					catchError((error) =>
						of(VendorAdminActions.userRoles.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
